import { connectedStore } from '../../store';
import actions from '../actions';

const setRenderStatus = (status) => {
  const store = connectedStore.get();
  store.dispatch(actions.setRenderStatus(status));
};

export default setRenderStatus;
